
export const REACT_APP_KINASTIC_ENVIRONMENT: string = 'beta';
// Application version (injected at build time)
export const REACT_APP_VERSION: string = process.env.REACT_APP_VERSION || '';
